import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import { PageTabRail } from '../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../../components/router/router-tabbed-navigation';
import { InventoryBooksOrdersTable } from '../../../../../../../../../../features/inventory/books-order/inventory-books-orders-table';
import { getPageHead } from '../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/books-order/_books-order/')({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsInventory,
      label: 'Books Orders',
      order: 0,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsInventory>,
  head: () => getPageHead('Books Orders'),
  component: BooksOrdersList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsInventory}
    />
  );
}

function BooksOrdersList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <InventoryBooksOrdersTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
